import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { QueryBuilderUtils } from "./QueryBuilderUtils";
import { ObjectUtils } from "../util/ObjectUtils";
import { TypeORMError } from "../error";
import { DriverUtils } from "../driver/DriverUtils";
/**
 * Stores all join attributes which will be used to build a JOIN query.
 */
export var JoinAttribute = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function JoinAttribute(connection, queryExpressionMap, joinAttribute) {
    _classCallCheck(this, JoinAttribute);
    this.connection = connection;
    this.queryExpressionMap = queryExpressionMap;
    this.isSelectedEvaluated = false;
    this.relationEvaluated = false;
    ObjectUtils.assign(this, joinAttribute || {});
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  _createClass(JoinAttribute, [{
    key: "isMany",
    get: function get() {
      if (this.isMappingMany !== undefined) return this.isMappingMany;
      if (this.relation) return this.relation.isManyToMany || this.relation.isOneToMany;
      return false;
    }
    /**
     * Indicates if this join is selected.
     */
  }, {
    key: "isSelected",
    get: function get() {
      var _this = this;
      if (!this.isSelectedEvaluated) {
        var getValue = function getValue() {
          var _iterator = _createForOfIteratorHelper(_this.queryExpressionMap.selects),
            _step;
          try {
            var _loop = function _loop() {
              var select = _step.value;
              if (select.selection === _this.alias.name) return {
                v: true
              };
              if (_this.metadata && !!_this.metadata.columns.find(function (column) {
                return select.selection === _this.alias.name + "." + column.propertyPath;
              })) return {
                v: true
              };
            };
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _ret = _loop();
              if (typeof _ret === "object") return _ret.v;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return false;
        };
        this.isSelectedCache = getValue();
        this.isSelectedEvaluated = true;
      }
      return this.isSelectedCache;
    }
    /**
     * Name of the table which we should join.
     */
  }, {
    key: "tablePath",
    get: function get() {
      return this.metadata ? this.metadata.tablePath : this.entityOrProperty;
    }
    /**
     * Alias of the parent of this join.
     * For example, if we join ("post.category", "categoryAlias") then "post" is a parent alias.
     * This value is extracted from entityOrProperty value.
     * This is available when join was made using "post.category" syntax.
     */
  }, {
    key: "parentAlias",
    get: function get() {
      if (!QueryBuilderUtils.isAliasProperty(this.entityOrProperty)) return undefined;
      return this.entityOrProperty.substr(0, this.entityOrProperty.indexOf("."));
    }
    /**
     * Relation property name of the parent.
     * This is used to understand what is joined.
     * For example, if we join ("post.category", "categoryAlias") then "category" is a relation property.
     * This value is extracted from entityOrProperty value.
     * This is available when join was made using "post.category" syntax.
     */
  }, {
    key: "relationPropertyPath",
    get: function get() {
      if (!QueryBuilderUtils.isAliasProperty(this.entityOrProperty)) return undefined;
      return this.entityOrProperty.substr(this.entityOrProperty.indexOf(".") + 1);
    }
    /**
     * Relation of the parent.
     * This is used to understand what is joined.
     * This is available when join was made using "post.category" syntax.
     * Relation can be undefined if entityOrProperty is regular entity or custom table.
     */
  }, {
    key: "relation",
    get: function get() {
      var _this2 = this;
      if (!this.relationEvaluated) {
        var getValue = function getValue() {
          if (!QueryBuilderUtils.isAliasProperty(_this2.entityOrProperty)) return undefined;
          var relationOwnerSelection = _this2.queryExpressionMap.findAliasByName(_this2.parentAlias);
          var relation = relationOwnerSelection.metadata.findRelationWithPropertyPath(_this2.relationPropertyPath);
          if (relation) {
            return relation;
          }
          if (relationOwnerSelection.metadata.parentEntityMetadata) {
            relation = relationOwnerSelection.metadata.parentEntityMetadata.findRelationWithPropertyPath(_this2.relationPropertyPath);
            if (relation) {
              return relation;
            }
          }
          throw new TypeORMError("Relation with property path ".concat(_this2.relationPropertyPath, " in entity was not found."));
        };
        this.relationCache = getValue.bind(this)();
        this.relationEvaluated = true;
      }
      return this.relationCache;
    }
    /**
     * Metadata of the joined entity.
     * If table without entity was joined, then it will return undefined.
     */
  }, {
    key: "metadata",
    get: function get() {
      // entityOrProperty is relation, e.g. "post.category"
      if (this.relation) return this.relation.inverseEntityMetadata;
      // entityOrProperty is Entity class
      if (this.connection.hasMetadata(this.entityOrProperty)) return this.connection.getMetadata(this.entityOrProperty);
      return undefined;
      /*if (typeof this.entityOrProperty === "string") { // entityOrProperty is a custom table
           // first try to find entity with such name, this is needed when entity does not have a target class,
          // and its target is a string name (scenario when plain old javascript is used or entity schema is loaded from files)
          const metadata = this.connection.entityMetadatas.find(metadata => metadata.name === this.entityOrProperty);
          if (metadata)
              return metadata;
           // check if we have entity with such table name, and use its metadata if found
          return this.connection.entityMetadatas.find(metadata => metadata.tableName === this.entityOrProperty);
      }*/
    }
    /**
     * Generates alias of junction table, whose ids we get.
     */
  }, {
    key: "junctionAlias",
    get: function get() {
      if (!this.relation) throw new TypeORMError("Cannot get junction table for join without relation.");
      if (this.relation.isOwning) {
        return DriverUtils.buildAlias(this.connection.driver, this.parentAlias, this.alias.name);
      } else {
        return DriverUtils.buildAlias(this.connection.driver, this.alias.name, this.parentAlias);
      }
    }
  }, {
    key: "mapToPropertyParentAlias",
    get: function get() {
      if (!this.mapToProperty) return undefined;
      return this.mapToProperty.split(".")[0];
    }
  }, {
    key: "mapToPropertyPropertyName",
    get: function get() {
      if (!this.mapToProperty) return undefined;
      return this.mapToProperty.split(".")[1];
    }
  }]);
  return JoinAttribute;
}();